var exports = {
  "k": "x93eb46d8--f0a617--container",
};

module.exports = exports;
